/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSellerItemTileCarousel_user" | "ContactDealerInlineForm_user" | "PdpSharedSellerTabsVariant_user" | "PdpSharedCallDealerCta_user" | "PdpSharedDealerDetailsHeader_user">;
    readonly " $refType": "PdpRespDealerDetails_user";
};
export type PdpRespDealerDetails_user$data = PdpRespDealerDetails_user;
export type PdpRespDealerDetails_user$key = {
    readonly " $data"?: PdpRespDealerDetails_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerDetails_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetails_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSellerItemTileCarousel_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDealerInlineForm_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedCallDealerCta_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsHeader_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'cabc8a07f6195337337f1dacce280f74';
export default node;
